import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AsyncContent } from '~/components/AsyncContent';
import { EmployeeDialogContent } from '~/components/EmployeeDialogContent';
import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { useGetPublicProfile } from '~/services/Http/hooks';

export interface Props {
  employeeId: number;
  onClose?: () => void;
}

export const PublicEmployeeDialogContent: React.FC<Props> = (props) => {
  const { employeeId, onClose } = props;
  const { t } = useTranslation();

  const getPublicProfileReqParams = useMemo(
    () => ({
      employeeId: employeeId.toString(),
    }),
    [employeeId],
  );
  const {
    loading,
    failedToLoad,
    data: employeeInfo,
  } = useGetPublicProfile(getPublicProfileReqParams);

  return (
    <div data-cy="public-employee-dialog-content">
      <SolaForceDialogTitle onClose={onClose}>
        {t('employeeInfo')}
      </SolaForceDialogTitle>
      <AsyncContent isLoading={loading} failedToLoad={failedToLoad}>
        {employeeInfo && <EmployeeDialogContent employee={employeeInfo} />}
      </AsyncContent>
    </div>
  );
};
